import React, { useRef, useState } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import Webcam from "react-webcam";

const WebcamCapture = () => {
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);

  const capturePhoto = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setCapturedImage(imageSrc);
      downloadImage(imageSrc);
    }
  };

  const downloadImage = (imageSrc) => {
    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = "webcam_image.png";
    link.click();
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h1>Webcam Capture</h1>
      <br />
      <div>
        <Link to="/">Home</Link>
      </div>
      <br />
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/png"
        style={{ width: "100%", maxWidth: "500px" }}
      />
      <br />
      <button onClick={capturePhoto} style={{ marginTop: "20px", padding: "10px 20px" }}>
        Take Picture
      </button>
      {capturedImage && (
        <div style={{ marginTop: "20px" }}>
          <h2>Captured Image:</h2>
          <img src={capturedImage} alt="Captured" style={{ width: "100%", maxWidth: "300px" }} />
        </div>
      )}
    </div>
  );
};

export default WebcamCapture;
